module.exports = __webpack_public_path__ + "static/media/sfl_4.d360dd62.jpg";